
<div class="page-layout simple fullwidth" fusePerfectScrollbar>
    <app-scrum-bread-bar></app-scrum-bread-bar>

  <!-- CONTENT -->
    <div class="content p-16 mat-white-bg">
  	  <mat-card style="text-align: right !important;margin-bottom: 10px;">
  	  	<div style="width: 100% !important;display: inline !important;text-align: right !important;">
  	  		<div style="display: inline-block !important;margin-top: 11px;padding: 0px !important;margin-right: 24px;">
		    	<button mat-button disabled color="primary">{{translations.btnFilterLabel}}</button>
			</div>

			<!-- <form [formGroup]="formGroup" novalidate> -->
	  	  	<mat-form-field style="margin-right: 10px !important;display: inline-block !important;" fxFlex.xs="100" fxFlex="20">
			  <input #dateFr matInput [matDatepicker]="picker" #filterDateFrom placeholder="{{translations.lblActualDeliveryFromDtFilter}}" readonly>
			  <mat-icon *ngIf="dateFr.value != ''" matSuffix (click)="clearDate(dateFr, picker)" style="font-size: 15px;cursor: pointer;">close</mat-icon>
			  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			  <mat-datepicker #picker></mat-datepicker>
			</mat-form-field>

			<mat-form-field style="margin-right: 10px !important;display: inline-block !important;" fxFlex.xs="100" fxFlex="20">
			  <input #dateTo matInput [matDatepicker]="pickerTo" #filterDateTo placeholder="{{translations.lblActualDeliveryToDtFilter}}" readonly>
			   <mat-icon *ngIf="dateTo.value != ''" matSuffix (click)="clearDate(dateTo, pickerTo)" style="font-size: 15px;cursor: pointer;">close</mat-icon>
			  <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
			  <mat-datepicker #pickerTo></mat-datepicker>
			</mat-form-field>

			<mat-form-field fxFlex.xs="100" fxFlex="10" style="margin-right: 10px !important;display: inline-block;">
		        <mat-select placeholder="{{translations.lblOrderStatusFillter}}" #filterStatus><!-- class="{{oStatus}}" -->
		            <mat-option [value]="0" selected>{{translations.filterOptionAll}}</mat-option> 
		            <mat-option *ngFor="let orderStatus of orderStatusList" [value]="orderStatus.Id" [style.color]="orderStatus.Value">{{orderStatus.Text}}</mat-option>
		          </mat-select>
		    </mat-form-field>
		    
		    <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="15">
	          <input matInput #filterShipperOrdNo placeholder="{{translations.filterOrderNumber}}" maxlength="25"/>
	      	</mat-form-field>
            
            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="10">
			        <mat-select #inpDistributor placeholder="Distributor" [(ngModel)]="distributorId">
			        	<mat-option [value]="zeroId">{{translations.filterOptionAll}}</mat-option>
			            <mat-option *ngFor="let distributor of distributorList" [value]="distributor.Id">{{distributor.Name}}</mat-option>
			        </mat-select>
			</mat-form-field>
		    
		    <div style="display: inline-block !important;margin-top: 8px;padding: 0px !important;">
		    	<button mat-raised-button color="primary" [disabled]="(filterDateFrom.value == '' && filterStatus.value == undefined) && !(filterShipperOrdNo.value.length > -1)" 
		    		(click)="filterOrders(filterDateFrom, filterDateTo, filterStatus, filterShipperOrdNo)">{{translations.btnFilterApply}}</button>
					<button mat-raised-button color="primary" [disabled]="(filterDateFrom.value == '' && filterStatus.value == undefined) && !(filterShipperOrdNo.value.length > -1)" 
						(click)="filterOrdersChart(filterDateFrom, filterDateTo, filterStatus, filterShipperOrdNo)">{{translations.btnCHart}}</button>
			</div>
			 <!-- <div style="display: inline-block !important;margin-top: 8px;padding: 0px !important;float: right;width: 25%;">
		    	<button mat-raised-button color="primary" [disabled]="filterDate.value == '' && filterStatus.value == undefined" (click)="filterOrders(filterDate, filterStatus)">Reset</button>
			</div> -->
	    </div>
  	  </mat-card>	
      <app-datatable *ngIf="data" #child [parent] ="this"  
	  				(view)="viewRecord($event)" 
	  				(edit)="editRecord($event)" 
	  				(delete)="deleteRecord($event)" 
					(add)="addRecord()" 
					(customeClick)="openCustomsDialog($event, type)" 
					(getPageWiseData)="getServerData($event)" 
					(getFilteredData)="applyFilter($event)" 
					(getSortedData)="getSortedData($event)" 
					(closeDialogue)="close()" 
      (indicator)="openRemarkEditor($event, orderId)">
      </app-datatable>
    </div>
    <!-- / CONTENT -->
  </div>
  
  


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order.component.html